import { useEffect } from 'react'
import { useQueryClient, useMutation } from 'react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { accountsService } from 'src/services/accounts.service'
import { useAuth } from 'src/hooks'

import { ROUTES } from 'src/constants'
import { joinAbsRoute, joinRelRoute } from 'src/common/utils'

const useAcceptAccountOwnership = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { mutateAsync } = useMutation((token: string) =>
    accountsService.acceptAccountOwnership(token),
  )
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { isAuthenticated } = useAuth()

  useEffect(() => {
    const token = searchParams.get('token')

    if (!token) {
      handleNavigate(`/${ROUTES.ACCOUNTS}`)
      return
    }

    ;(async () => {
      const resp = await mutateAsync(token)

      if (!resp) {
        return handleNavigate(isAuthenticated ? joinAbsRoute(ROUTES.ACCOUNTS) : ROUTES.LOGIN)
      }

      if (!resp.user.agreement) {
        return handleNavigate(
          resp.registrationToken
            ? joinRelRoute(
                ROUTES.REGISTER_FINISH,
                `${resp.registrationToken}?email=${resp.user.email}${
                  resp.user.agreement_with_account ? '' : '&without_account=true'
                }&with_password=true`,
              )
            : ROUTES.REGISTER,
        )
      }

      handleNavigate(
        isAuthenticated
          ? joinAbsRoute(ROUTES.ACCOUNTS, resp.account.id, ROUTES.DASHBOARD)
          : ROUTES.LOGIN,
      )
    })()

    function handleNavigate(to: string) {
      setTimeout(() => {
        navigate(to)
      }, 1500)
    }
  }, [isAuthenticated, mutateAsync, navigate, queryClient, searchParams, setSearchParams])
}

export { useAcceptAccountOwnership }
